import React, { useState, useEffect, useContext } from 'react';
import RequestService from '../../services/RequestService';
import TableComponent from '../../widgets/TableComponent';
import UserDialog from '../../widgets/users/UserDialog';
import NewUserDialog from '../../widgets/users/NewUserDialog';
import UserList from '../../widgets/users/UserList';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import ThumbDownAltOutlinedIcon from '@mui/icons-material/ThumbDownAltOutlined';
import RewardBadge from '../../widgets/RewardBadge';
import { ReactComponent as CoinIcon } from '../../assets/icons/coin.svg';
import { ReactComponent as XpIcon } from '../../assets/icons/xp.svg';

import {
    Grid2 as Grid,
    Typography,
    Breadcrumbs,
    Link,
    Stack,
    Chip,
    TextField,
    Button,
    Box,
    Snackbar,
    Alert,
    useMediaQuery,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Tooltip,
} from '@mui/material';
import { UserContext } from '../../contexts/UserContext';
import { useTheme } from '@mui/material/styles';
import { shouldHideEmail } from '../../utils/emailUtils';
import CodeDialog from '../../widgets/users/CodeDialog';
import UserDeleteDialog from '../../widgets/users/UserDeleteDialog';
import CoinDialog from '../../widgets/users/CoinDialog';
import PenaltyDialog from '../../widgets/users/PenaltyDialog';

const PlayersPage = () => {
    const { user, hasPermission } = useContext(UserContext);
    const [players, setPlayers] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const [selectedPlayer, setSelectedPlayer] = useState(null);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isAddDialogOpen, setIsAddDialogOpen] = useState(false);
    const [isCodeDialogOpen, setIsCodeDialogOpen] = useState(false);
    const [isDeleteDialogOpen, setIsDeleteDialogOpenn] = useState(false);
    const [isCoinDialogOpen, setIsCoinDialogOpen] = useState(false);
    const [isPenaltyDialogOpen, setIsPenaltyDialogOpen] = useState(false);

    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');

    const [searchTerm, setSearchTerm] = useState('');
    const [groupId, setGroupId] = useState('');
    const [gameId, setGameId] = useState('');
    const [groups, setGroups] = useState([]);
    const [games, setGames] = useState([]);

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    useEffect(() => {
        fetchPlayers();
    }, []);

    const fetchPlayers = async () => {
        try {
            setLoading(true);
            const data = await RequestService.getUsersByCompany(
                user.company.id,
                searchTerm,
                groupId,
                gameId
            );
            setPlayers(data);
            setLoading(false);
        } catch (err) {
            setError('Erro ao carregar jogadores.');
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchFilters = async () => {
            try {
                const groupData = await RequestService.getGroups(
                    user.company.id
                );
                setGroups(Array.isArray(groupData) ? groupData : []);

                const gameData = await RequestService.getGames(user.company.id);
                setGames(Array.isArray(gameData) ? gameData : []);
            } catch (err) {
                console.error('Erro ao carregar filtros:', err);
            }
        };

        fetchFilters();
    }, [user.company.id]);

    const handleRowClick = (player) => {
        if (hasPermission('USER_UPDATE')) {
            setSelectedPlayer(player);
            setIsDialogOpen(true);
        }
    };

    const handleCloseDialog = () => {
        setIsDialogOpen(false);
        setSelectedPlayer(null);
    };

    const handleOpenAddDialog = () => setIsAddDialogOpen(true);
    const handleCloseAddDialog = () => setIsAddDialogOpen(false);

    const handlCloseDeleteDialog = () => {
        setIsDeleteDialogOpenn(false);
        setSelectedPlayer(null);
    };

    const handleOpenDeleteDialog = (player) => {
        setSelectedPlayer(player);
        setIsDeleteDialogOpenn(true);
    };

    const handleOpenCoinDialog = () => {
        setIsCoinDialogOpen(true);
    };

    const handleCloseCoinDialog = () => {
        setSelectedPlayer(null);
        setIsCoinDialogOpen(false);
    };

    const handleOpenPenaltyDialog = (player) => {
        setSelectedPlayer(player);
        setIsPenaltyDialogOpen(true);
    };

    const handleClosePenaltyDialog = () => {
        setSelectedPlayer(null);
        setIsPenaltyDialogOpen(false);
    };

    const handleSuccessAdd = async () => {
        const data = await RequestService.getUsersByCompany(user.company.id);
        setPlayers(data);

        setSnackbarMessage('Usuário criado com sucesso!');
        setSnackbarOpen(true);
    };

    const handleSuccessEdit = async () => {
        const data = await RequestService.getUsersByCompany(user.company.id);
        setPlayers(data);

        setSnackbarMessage('Operação concluída com sucesso!');
        setSnackbarOpen(true);
    };

    const handleSuccessExclude = async () => {
        const data = await RequestService.getUsersByCompany(user.company.id);
        setPlayers(data);

        setSnackbarMessage('Usuário excluído com sucesso!');
        setSnackbarOpen(true);
    };

    const handleSuccessAddCoin = async () => {
        const data = await RequestService.getUsersByCompany(user.company.id);
        setPlayers(data);

        setSnackbarMessage('Operação executada com sucesso!');
        setSnackbarOpen(true);
    };

    const handleSuccessPenalty = async () => {
        const data = await RequestService.getUsersByCompany(user.company.id);
        setPlayers(data);

        setSnackbarMessage('Atitude negativa atribuída com!');
        setSnackbarOpen(true);
    };

    const handleSnackbarClose = () => {
        setSnackbarOpen(false);
    };

    if (loading) return <div>Carregando...</div>;
    if (error) return <div>{error}</div>;

    const columns = [
        { label: 'Nome', field: 'name' },
        {
            label: 'E-mail',
            field: 'email',
            renderCell: (cell) => {
                const email = typeof cell === 'string' ? cell : cell?.email;
                const companyName = user?.company?.name || '';

                if (shouldHideEmail(email, companyName)) {
                    return <Typography>Não possui e-mail próprio</Typography>;
                }

                return <Typography>{email}</Typography>;
            },
        },
        { label: 'Nível de Acesso', field: 'role', align: 'center' },
        {
            label: 'Grupos',
            field: 'groups',
            renderCell: (groups = []) => {
                const first = groups[0];
                const extra = Math.max(0, groups.length - 1);

                if (!first) {
                    return (
                        <Typography variant="body2" color="text.secondary">
                            —
                        </Typography>
                    );
                }

                return (
                    <Stack
                        direction="row"
                        spacing={0.5}
                        alignItems="flex-start"
                    >
                        <Chip label={first.name} size="small" color="primary" />

                        {extra > 0 && (
                            <Chip
                                label={`+${extra}`}
                                size="small"
                                color="primary"
                                // se quiser evitar abrir o diálogo ao clicar na linha:
                                onClick={(e) => e.stopPropagation()}
                            />
                        )}
                    </Stack>
                );
            },
        },
        {
            label: 'Moedas',
            field: 'coin',
            renderCell: (row) => (
                <Stack direction="column" spacing={2} alignItems="start">
                    <RewardBadge
                        icon={
                            <CoinIcon
                                style={{
                                    color: '#134F99',
                                    fontSize: '24px',
                                }}
                            />
                        }
                        value={row}
                        positive="true"
                    />
                </Stack>
            ),
        },
        {
            label: 'Experiência',
            field: 'exp',
            renderCell: (row) => (
                <Stack direction="column" spacing={2} alignItems="start">
                    <RewardBadge
                        icon={
                            <XpIcon
                                style={{
                                    color: '#134F99',
                                    fontSize: '24px',
                                }}
                            />
                        }
                        value={row}
                        positive="true"
                    />
                </Stack>
            ),
        },
    ];

    const renderActions = (row) => (
        <Stack direction="row" spacing={2} alignItems="center" flexWrap="wrap">
            {hasPermission('USER_AWARD') && (
                <Link
                    component="button"
                    onClick={() => {
                        setSelectedPlayer(row);
                        handleOpenCoinDialog();
                    }}
                    underline="none"
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <PaidOutlinedIcon fontSize="small" />
                        <Typography>Gerenciar moedas</Typography>
                    </Stack>
                </Link>
            )}
            {hasPermission('USER_VIEW') && (
                <Link
                    component="button"
                    onClick={() => {
                        setSelectedPlayer(row);
                        setIsCodeDialogOpen(true);
                    }}
                    underline="none"
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <QrCodeScannerIcon fontSize="small" />
                        <Typography>QR-Code</Typography>
                    </Stack>
                </Link>
            )}
            {hasPermission('USER_PENALTY') && (
                <Link
                    component="button"
                    onClick={() => handleOpenPenaltyDialog(row)}
                    underline="none"
                    sx={{ color: 'red' }}
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <ThumbDownAltOutlinedIcon fontSize="small" />
                        <Typography>Penalizar</Typography>
                    </Stack>
                </Link>
            )}
            {hasPermission('USER_DELETE') && (
                <Link
                    component="button"
                    onClick={() => handleOpenDeleteDialog(row)}
                    underline="none"
                    sx={{ color: 'red' }}
                >
                    <Stack direction="row" spacing={1} alignItems="center">
                        <DeleteOutlinedIcon fontSize="small" />
                        <Typography>Excluir</Typography>
                    </Stack>
                </Link>
            )}
        </Stack>
    );

    const renderEmptyState = () => (
        <Box
            sx={{
                textAlign: 'center',
                mt: 4,
                color: '#666',
                fontFamily: 'Poppins',
                fontSize: 18,
            }}
        >
            <Typography variant="h6">Nenhum jogador cadastrado.</Typography>
            <Typography variant="body2">
                Clique em <strong>"Novo jogador"</strong> para adicionar o
                primeiro!
            </Typography>
        </Box>
    );

    const renderMobileLayout = () => {
        return players.length === 0 ? (
            renderEmptyState()
        ) : (
            <UserList
                users={players}
                onUserClick={handleRowClick}
                onDeleteClick={handleOpenDeleteDialog}
            />
        );
    };

    const renderDesktopLayout = () => {
        return players.length === 0 ? (
            renderEmptyState()
        ) : (
            <Grid container justifyContent="center" xs={12}>
                <Box sx={{ width: '100%', overflowX: 'auto', mt: 2 }}>
                    <TableComponent
                        columns={columns}
                        rows={players}
                        onRowClick={handleRowClick}
                        renderRowBottom={renderActions}
                    />
                </Box>
            </Grid>
        );
    };

    return (
        <Box>
            <Grid container justifyContent="start">
                <Breadcrumbs aria-label="breadcrumb">
                    <Link underline="hover" color="inherit" href="/">
                        GameUP
                    </Link>
                    <Link underline="hover" color="inherit">
                        Início
                    </Link>
                    <Typography sx={{ color: 'text.primary' }}>
                        Jogadores
                    </Typography>
                </Breadcrumbs>
            </Grid>

            <Grid container xs={12} sx={{ mt: 3 }}>
                <Typography
                    sx={{
                        fontFamily: 'Poppins',
                        fontSize: 24,
                        fontWeight: '500',
                        color: '#0C3466',
                        mb: 2,
                    }}
                >
                    Lista de Jogadores
                </Typography>
            </Grid>

            <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="space-between"
                wrap="wrap"
            >
                {/* Left side: filters */}
                <Grid container item xs={12} md={9} spacing={2}>
                    {/* Search */}
                    <Grid item xs={12} sm={6} md={3}>
                        <TextField
                            id="search"
                            label="Pesquisar Nome"
                            variant="outlined"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') {
                                    fetchPlayers();
                                }
                            }}
                            fullWidth
                        />
                    </Grid>
                    {/* Grupo */}
                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl sx={{ minWidth: 200, width: '100%' }}>
                            <InputLabel>Grupo</InputLabel>
                            <Select
                                value={groupId}
                                onChange={(e) => setGroupId(e.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {groups.map((group) => (
                                    <MenuItem key={group.id} value={group.id}>
                                        {group.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    {/* Jogo */}
                    <Grid item xs={12} sm={6} md={3}>
                        <FormControl sx={{ minWidth: 200, width: '100%' }}>
                            <InputLabel>Jogo</InputLabel>
                            <Select
                                value={gameId}
                                onChange={(e) => setGameId(e.target.value)}
                            >
                                <MenuItem value="">Todos</MenuItem>
                                {games.map((game) => (
                                    <MenuItem key={game.id} value={game.id}>
                                        {game.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* Aplicar Filtros */}
                    <Grid item xs={12} sm={6} md={3}>
                        <Button
                            variant="contained"
                            sx={{
                                minHeight: '47px',
                            }}
                            onClick={fetchPlayers}
                            fullWidth
                        >
                            Aplicar Filtros
                        </Button>
                    </Grid>
                </Grid>

                {/* Right side: “Nova Missão” button */}
                <Grid item xs={12} md="auto">
                    {hasPermission('USER_CREATE') && (
                        <Button
                            variant="contained"
                            sx={{
                                minHeight: '47px',
                            }}
                            endIcon={<AddCircleOutlineOutlinedIcon />}
                            onClick={handleOpenAddDialog}
                        >
                            Novo jogador
                        </Button>
                    )}
                </Grid>
            </Grid>

            {isMobile ? renderMobileLayout() : renderDesktopLayout()}

            <UserDialog
                open={isDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseDialog();
                    }
                }}
                user={user}
                player={selectedPlayer}
                onSuccess={handleSuccessEdit}
            />

            <NewUserDialog
                open={isAddDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseAddDialog();
                    }
                }}
                onSuccess={handleSuccessAdd}
                user={user}
            />

            <CodeDialog
                open={isCodeDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        setIsCodeDialogOpen(false);
                    }
                }}
                user={selectedPlayer}
                companyId={user.company.id}
                company={user.company}
            />

            <UserDeleteDialog
                open={isDeleteDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handlCloseDeleteDialog();
                    }
                }}
                user={selectedPlayer}
                onSuccess={handleSuccessExclude}
            />

            <CoinDialog
                open={isCoinDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleCloseCoinDialog();
                    }
                }}
                user={selectedPlayer}
                onSuccess={handleSuccessAddCoin}
            />

            <PenaltyDialog
                open={isPenaltyDialogOpen}
                onClose={(event, reason) => {
                    if (reason !== 'backdropClick') {
                        handleClosePenaltyDialog();
                    }
                }}
                companyId={user.company.id}
                seasonId={user.company.season}
                user={selectedPlayer}
                onSuccess={handleSuccessPenalty}
            />

            <Snackbar
                open={snackbarOpen}
                autoHideDuration={3000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleSnackbarClose}
                    severity="success"
                    variant="filled"
                >
                    {snackbarMessage}
                </Alert>
            </Snackbar>
        </Box>
    );
};

export default PlayersPage;
